import {onDomReady} from "./observer.js";

class Datings {
    constructor() {
        this.options = {
            datingsFilterAdv: '[data-vipfilter]',
            datingsFilterAdvBack: '[data-vipfilter-back]',
            datingsFilterAdvClose: '[data-vipfilter-close]',
            datingsFilterAdvOverlay: '[data-vipfilter-overlay]',
            datingsFilterAdvOpener: '[data-vipfilter-opener]',
            datingsFilterOverlayOpened: '_opened',
            entirePage: '[data-body]',
            noScroll: 'body-fixed',
        };

        this.elements = {
            entirePageElement: document.querySelector(this.options.entirePage),
            datingsFilterAdvElement: document.querySelector(this.options.datingsFilterAdv),
            datingsFilterAdvBackElement: document.querySelector(this.options.datingsFilterAdvBack),
            datingsFilterAdvCloseElement: document.querySelector(this.options.datingsFilterAdvClose),
            datingsFilterAdvOverlayElement: document.querySelector(this.options.datingsFilterAdvOverlay),
            datingsFilterAdvOpenerElement: document.querySelector(this.options.datingsFilterAdvOpener),
            datingsFilterOverlayOpenedElement: document.querySelector(this.options.datingsFilterOverlayOpened),
        };

        this.init();
    }

    init() {

        if (this.elements.datingsFilterAdvBackElement &&
            this.elements.datingsFilterAdvCloseElement &&
            this.elements.datingsFilterAdvOverlayElement &&
            this.elements.datingsFilterAdvOpenerElement &&
            this.elements.entirePageElement &&
            this.elements.datingsFilterAdvElement) {


            const vipFilter = this.elements.datingsFilterAdvElement;
            const vipFilterOverlay = this.elements.datingsFilterAdvOverlayElement;
            const vipFilterBack = this.elements.datingsFilterAdvBackElement;
            const vipFilterClose = this.elements.datingsFilterAdvCloseElement;
            const vipFilterOpener = this.elements.datingsFilterAdvOpenerElement;
            const entirePage = this.elements.entirePageElement;

            console.log(vipFilterOpener);
            vipFilterOpener.addEventListener('click', () => {
                vipFilterOverlay.classList.add(this.options.datingsFilterOverlayOpened);
                vipFilter.classList.add(this.options.datingsFilterOverlayOpened);
                entirePage.classList.add(this.options.noScroll);
            });
            vipFilterBack.addEventListener('click', () => {
                vipFilterOverlay.classList.remove(this.options.datingsFilterOverlayOpened);
                vipFilter.classList.remove(this.options.datingsFilterOverlayOpened);
                entirePage.classList.remove(this.options.noScroll);
            });

            vipFilterClose.addEventListener('click', () => {
                vipFilterOverlay.classList.remove(this.options.datingsFilterOverlayOpened);
                vipFilter.classList.remove(this.options.datingsFilterOverlayOpened);
                entirePage.classList.remove(this.options.noScroll);
            });

            vipFilterOverlay.addEventListener('click', () => {
                vipFilterOverlay.classList.remove(this.options.datingsFilterOverlayOpened);
                vipFilter.classList.remove(this.options.datingsFilterOverlayOpened);
                entirePage.classList.remove(this.options.noScroll);
            });

        }
    }
}

onDomReady(() => {
    const header = new Datings();
}, false);